import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Snackbar, TextField} from '@mui/material'
import {general as textsGeneral} from '../../translate/Translate.jsx'
import Button from '../../components/button/Button.jsx'
import {
    DialogCodeRecoveryPassword,
    DialogForgotPassword,
    DialogLoading,
    DialogResetPassword, DialogWarning
} from '../../components/dialogs/Dialogs.jsx'
import Header from '../../components/header/Header.jsx'
import {colors, linkApp} from '../../utils/utils.jsx'

import {getLocal, setLocal} from '../../hooks/useStorage/useStorage.jsx'
import {getLogin, getRecoveryPassword, postClient, postCode, postEmail, putClient} from '../../services/Apis.jsx'
import {cleanTextToNumbers, isEmail, randomNumber} from 'react-lf-tools'

import {motion} from 'framer-motion'
import './login.scss'
import themeMui from "../../themeMui.jsx";
import {ThemeProvider} from "@mui/material/styles";

const Login = () => {
    const navigate = useNavigate()
    const [user, setUser] = useState({
        email: '',
        password: ''
    })
    const [dialogForgotPassword, setDialogForgotPassword] = useState({
        open: false
    })
    const [dialogCodeRecoveryPassword, setDialogCodeRecoveryPassword] = useState({
        open: false
    })
    const [dialogResetPassword, setDialogResetPassword] = useState({
        open: false,
        client: {}
    })
    const [dialogWarning, setDialogWarning] = useState({
        open: false
    })
    const [dialogLoading, setDialogLoading] = useState({
        open: false,
        message: ''
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })

    const handleInput = e => setUser({...user, [e.target.name]: e.target.value.trim()})

    const handleClickLogin = async () => {
        try {
            if (!isEmail(user.email)) return setSnackbar({
                open: true,
                message: textsGeneral.invalidEmail
            })
            if (!user.password) return setSnackbar({
                open: true,
                message: textsGeneral.invalidPassword
            })
            const request = {
                email: user.email,
                password: user.password
            }
            setDialogLoading({open: true, message: ''})
            const {returnCode, message, data} = await getLogin(request)
            setDialogLoading({...dialogLoading, open: false})
            if (!!returnCode) {
                if (!data) return setSnackbar({
                    open: true,
                    message: textsGeneral.invalidEmailOrPassword
                })
                const profile = {
                    name: data.nome,
                    phone: cleanTextToNumbers(`${data.ddd}${data.telefone}`),
                    cpf: cleanTextToNumbers(data.cpf),
                    loggedIn: true,
                    key: data.key
                }
                setLocal('profile', profile)
                const myAddress = []
                data.endereco.map(e => myAddress.push({
                    id: randomNumber(10),
                    street: e.rua,
                    neighborhood: e.bairro,
                    city: e.cidade,
                    zipCode: e.cep,
                    uf: e.uf,
                    number: e.numero,
                    addressComplement: e.complemento,
                    latitude: !!e?.latitude ? e?.latitude : '',
                    longitude: !!e?.longitude ? e?.longitude : ''
                }))
                setLocal('myAddress', myAddress)
                navigate(-1)
            } else {
                setSnackbar({
                    open: true,
                    message: message
                })
            }
        } catch (e) {
            console.error(e.message)
        }
    }

    const handleClickDialogForgotPassword = () => setDialogForgotPassword({open: true})

    const handleCloseForgotPassword = () => setDialogForgotPassword({open: false})

    const handleClickForgotPassword = async email => {
        if (!isEmail(email)) return setSnackbar({
            open: true,
            message: textsGeneral.invalidEmail
        })
        setUser({...user, email: email})
        const requestRecoveryPassword = {email: email}
        setDialogForgotPassword({open: false})
        setDialogLoading({open: true, message: textsGeneral.checkingEmail})
        const {returnCode, message, data} = await getRecoveryPassword(requestRecoveryPassword)
        setDialogLoading({...dialogLoading, open: false})
        if (!returnCode) return setSnackbar({
            open: true,
            message: message
        })
        const code = randomNumber(6)
        const client = Object.values(data)[0]
        client.redefinir = code
        const requestClient = {
            json: client,
            key: client.key
        }
        setDialogLoading({open: true, message: textsGeneral.generatingCode})
        const responseClient = await postClient(requestClient)
        setDialogLoading({...dialogLoading, open: false})
        const mail = {
            from: 'contato@bitbar.com.br',
            subject: textsGeneral.recoverPassword,
            destination: email,
            name: client.nome,
            body: bodyEmail(linkApp(), code)
        }

        setDialogLoading({open: true, message: textsGeneral.sendingEmail})
        await postEmail(mail)
        setDialogLoading({...dialogLoading, open: false})
        setDialogCodeRecoveryPassword({open: true})
    }

    const handleCloseCodeRecoveryPassword = () => setDialogCodeRecoveryPassword({open: false})

    const handleClickCodeRecoveryPassword = async (code) => {
        const requestCode = {
            code: code,
            email: user.email
        }
        setDialogCodeRecoveryPassword({open: false})
        setDialogLoading({open: true, message: textsGeneral.verifyingCode})
        const {returnCode, data} = await postCode(requestCode)
        setDialogLoading({...dialogLoading, open: false})
        if (!!returnCode && !!data) {
            setDialogResetPassword({
                open: true,
                client: data
            })
        } else {
            setSnackbar({open: true, message: textsGeneral.invalidCode})
        }
    }

    const handleCloseCodeResetPassword = () => setDialogResetPassword({...dialogResetPassword, open: false})

    const handleClickCodeResetPassword = async (password, client) => {
        if (password.length < 5) return setSnackbar({
            open: true,
            message: textsGeneral.invalidPassword
        })
        const requestClient = {
            password: password,
            client: client
        }
        setDialogResetPassword({...dialogResetPassword, open: false})
        setDialogLoading({open: true, message: textsGeneral.changingPassword})
        const {returnCode, message, data} = await putClient(requestClient)
        setDialogLoading({...dialogLoading, open: false})
        if (!!returnCode) {
            const profile = {
                name: data.nome,
                phone: cleanTextToNumbers(`${data.ddd}${data.telefone}`),
                cpf: cleanTextToNumbers(data.cpf)
            }
            setLocal('profile', profile)
            setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: textsGeneral.passwordChanged
            })
        } else {
            setSnackbar({open: true, message: message || ''})
        }
    }

    const handleClickDialogWarning = () => navigate(-1)

    const bodyEmail = (link, code) => {
        return `<html lang="pt-br">
                <head>
                    <meta charset="UTF-8">                
                    <style>
                        body {
                            margin: 0px;
                            width: 100%;
                            background-color: white;
                        }                
                        #toolbar {
                            width: 100%;
                            height: 120px;                            
                        }                
                        #img-logo {
                            width: 80px;
                            height: 80px;          
                            margin: 8px;                
                        }
                        a { 
                            color: #61b4da;                             
                            margin: 8px;
                        }                         
                        #div-main {
                            width: 100%;
                            padding: 8px;
                        }                                                                            
                    </style>
                </head>
                <body>
                    <div id="toolbar">
                        <img src="https://firebasestorage.googleapis.com/v0/b/bitmenu-57f8f.appspot.com/o/2.png?alt=media&token=d18af25e-0d6a-4e3d-9ec2-7bab695803a3" alt="" id="img-logo" />
                    </div>
                    <div id="div-main">
                        <h2>Recuperação de senha</h2>     
                        <h3>1º Copie o código de recuperação</h3>
                        <h3>2º Clique no link abaixo</h3>
                        <h3>Código de recuperação: ${code}</h3>                  
                        <a href="${link}">${link}</a>                                                                                                  
                    </div>                                
                </body>                            
                </html>`
    }

    const handleCloseSnackbar = () => setSnackbar({...snackbar, open: false})

    const styles = getLocal('colors')

    colors(document)

    return <ThemeProvider theme={themeMui(styles)}>
        <motion.div
            initial={{x: 400}}
            animate={{x: 0}}
            transition={{duration: 0.3}}>
            <div className={'login'}>
                <Header title={textsGeneral.login} buttonBack={true}/>
                <div className={'container-login'}>
                    <TextField
                        autoFocus={true}
                        margin={'normal'}
                        InputLabelProps={{shrink: true}}
                        color={'secondary'}
                        type={'email'}
                        placeholder={textsGeneral.email}
                        label={textsGeneral.email}
                        fullWidth={true}
                        name={'email'}
                        onChange={handleInput}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') handleClickLogin()
                        }}
                    />
                    <TextField
                        margin={'normal'}
                        InputLabelProps={{shrink: true}}
                        color={'secondary'}
                        type={'password'}
                        placeholder={textsGeneral.password}
                        label={textsGeneral.password}
                        fullWidth={true}
                        name={'password'}
                        onChange={handleInput}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') handleClickLogin()
                        }}
                    />
                    <Button
                        className={'button-login'}
                        title={textsGeneral.login}
                        onClick={handleClickLogin}
                    />
                    <Button
                        className={'button-login'}
                        title={textsGeneral.forgotMyPassword}
                        variant={'text'}
                        onClick={handleClickDialogForgotPassword}
                    />
                </div>
                <>
                    <DialogLoading
                        open={dialogLoading.open}
                        message={dialogLoading.message}
                    />
                    <DialogForgotPassword
                        open={dialogForgotPassword.open}
                        onClose={handleCloseForgotPassword}
                        onClick={handleClickForgotPassword}
                    />
                    <DialogCodeRecoveryPassword
                        open={dialogCodeRecoveryPassword.open}
                        onClose={handleCloseCodeRecoveryPassword}
                        onClick={handleClickCodeRecoveryPassword}
                    />
                    <DialogResetPassword
                        open={dialogResetPassword.open}
                        client={dialogResetPassword.client}
                        onClose={handleCloseCodeResetPassword}
                        onClick={handleClickCodeResetPassword}
                    />
                    <DialogWarning
                        open={dialogWarning.open}
                        title={dialogWarning.title}
                        message={dialogWarning.message}
                        onClick={handleClickDialogWarning}
                    />
                    <Snackbar
                        open={snackbar.open}
                        autoHideDuration={1600}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}/>
                </>
            </div>
        </motion.div>
    </ThemeProvider>
}

export default Login
